import type { Translate } from '@shared/hooks/locale';

export type ListingCharacteristicsData = {
  number_of_bedrooms?: number | null;
  number_of_rooms?: number | null;
  computed_surface?: number | null;
  land_surface?: number | null;
};

export const getPropertyCharacteristics = (
  listing: ListingCharacteristicsData,
  countryCode: string,
  t: Translate,
): string => {
  const characteristics: string[] = [];

  const number_of_bedrooms = listing.number_of_bedrooms ?? 0;
  const number_of_rooms = listing.number_of_rooms ?? 0;
  const computed_surface = listing.computed_surface ?? 0;
  const land_surface = listing.land_surface ?? 0;

  // For Spain, prefer bedrooms count if available (on comparable listings)
  if (countryCode === 'ES' && number_of_bedrooms > 0) {
    // For Spain, use "bedrooms" or fall back to "rooms" terminology if translation issue
    characteristics.push(t('bedroomsCount', { count: number_of_bedrooms }));
  } else if (number_of_rooms > 0) {
    characteristics.push(t('roomsCount', { count: number_of_rooms }));
  }

  // Only add surface if it's greater than 0
  if (computed_surface > 0) {
    characteristics.push(`${computed_surface} m²`);
  }

  // Only add land surface if it's greater than 0
  if (land_surface > 0) {
    characteristics.push(t('plotSurfaceOf', { plotSurface: land_surface }));
  }

  return characteristics.join(' · ');
};
